// ContactSection.jsx
import { useState, useContext } from "react";
import "../../../assets/css/student/contact/ContactSection.css";
import AppContext from '../../../context/AppContext';
const ContactSection = () => {

  const { baseUrl, regExpChecker } = useContext(AppContext);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");
  const [privacy, setPrivacy] = useState(false);

  // Errors
  const [firstNameError, setFirstNameError] = useState("");
  const [lastNameError, setLastNameError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [messageError, setMessageError] = useState("");


  const [csFormData, setCsFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    company: "",
    message: "",
    privacy: false,
  });

  const [csSubmitted, setCsSubmitted] = useState(false);

  // ============ INPUT HANDLER ============
  const handleCsInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setCsFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  // ============ SUBMIT HANDLER ============
  const handleCsSubmit = (e) => {
    e.preventDefault();
    if (!csFormData.privacy) {
      alert("Please agree to the Privacy Policy.");
      return;
    }
    console.log("Form submitted:", csFormData);
    setCsSubmitted(true);
  };

  return (
    <section className="cs-section">
      <div className="cs-wrapper">

        {/* ===== LEFT SIDE ===== */}
        <div className="cs-left">

          {/* Google Map - Simple iframe embed (no API key needed) */}
          <div className="cs-map-container">
            <iframe
              title="Office Location"
              className="cs-map-iframe"
              loading="lazy"
              allowFullScreen
              referrerPolicy="no-referrer-when-downgrade"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2483.1!2d-0.1749!3d51.5149!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48760567da220a01%3A0xac7a11b965a93571!2s30%20Eastbourne%20Terrace%2C%20London%20W2%206LE%2C%20UK!5e0!3m2!1sen!2s!4v1"
            />
          </div>

          {/* Description */}
          <p className="cs-description">
            Working hand in hand with communities, we aim to deliver hope,
            education, and essential support where it's needed most.
          </p>

          {/* Address Grid */}
          <div className="cs-address-grid">

            {/* UK */}
            <div className="cs-address-col">
              <h4 className="cs-address-country">United Kingdom</h4>
              <div className="cs-address-item">
                <span className="cs-icon cs-icon-location">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0 1 18 0z" />
                    <circle cx="12" cy="10" r="3" />
                  </svg>
                </span>
                <span className="cs-address-text">
                  30 Easbourne Terrace <br />
                  Paddington, London W2 BLA, 6K
                </span>
              </div>
              <div className="cs-address-item">
                <span className="cs-icon cs-icon-phone">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2A19.79 19.79 0 0 1 11.27 19a19.45 19.45 0 0 1-6-6A19.79 19.79 0 0 1 2.12 4.18 2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" />
                  </svg>
                </span>
                <span className="cs-address-text">+44 20 7946 0958</span>
              </div>
              <div className="cs-address-item">
                <span className="cs-icon cs-icon-email">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                    <polyline points="22,6 12,13 2,6" />
                  </svg>
                </span>
                <span className="cs-address-text">hello@fauncharity.com</span>
              </div>
            </div>

            {/* US */}
            <div className="cs-address-col">
              <h4 className="cs-address-country">United States</h4>
              <div className="cs-address-item">
                <span className="cs-icon cs-icon-location">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0 1 18 0z" />
                    <circle cx="12" cy="10" r="3" />
                  </svg>
                </span>
                <span className="cs-address-text">
                  245 West 29th Street, 23th <br />
                  Avenue, New York, NY 10001
                </span>
              </div>
              <div className="cs-address-item">
                <span className="cs-icon cs-icon-phone">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2A19.79 19.79 0 0 1 11.27 19a19.45 19.45 0 0 1-6-6A19.79 19.79 0 0 1 2.12 4.18 2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" />
                  </svg>
                </span>
                <span className="cs-address-text">+1 (212) 555-8746</span>
              </div>
              <div className="cs-address-item">
                <span className="cs-icon cs-icon-email">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                    <polyline points="22,6 12,13 2,6" />
                  </svg>
                </span>
                <span className="cs-address-text">hello.us@fauncharity.com</span>
              </div>
            </div>

          </div>
        </div>

        {/* ===== RIGHT SIDE — FORM ===== */}
        <div className="cs-right">
          {csSubmitted ? (
            <div className="cs-success">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                className="cs-success-icon">
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                <polyline points="22 4 12 14.01 9 11.01" />
              </svg>
              <h3>Message Sent!</h3>
              <p>Thank you for reaching out. We'll get back to you shortly.</p>
            </div>
          ) : (
            <form className="cs-form" onSubmit={handleCsSubmit} noValidate>

              {/* First + Last Name */}
              <div className="cs-form-row">
                <div className="cs-form-group">
                  <label className="cs-label">First Name</label>
                  <input
                    type="text"
                    name="firstName"
                    className="cs-input"
                    placeholder="John"
                    value={firstName}
                    onChange={(e) => {
                      setFirstName(e.target.value);
                      setFirstNameError(regExpChecker("username", e.target.value));
                    }}
                    required
                  />
                  <p style={{ color: "red" }}>{firstNameError}</p>
                </div>
                <div className="cs-form-group">
                  <label className="cs-label">Last Name</label>
                  <input
                    type="text"
                    name="lastName"
                    className="cs-input"
                    placeholder="Doe"
                    value={lastName}
                    onChange={(e) => {
                      setLastName(e.target.value);
                      setLastNameError(regExpChecker("username", e.target.value));
                    }}
                    required
                  />
                  <p style={{ color: "red" }}>{lastNameError}</p>
                </div>
              </div>

              {/* Email */}
              <div className="cs-form-group">
                <label className="cs-label">Email Address</label>
                <input
                  type="email"
                  name="email"
                  className="cs-input"
                  placeholder="yourname@example.com"
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                    setEmailError(regExpChecker("email", e.target.value));
                  }}
                  required
                />
                <p style={{ color: "red" }}>{emailError}</p>
              </div>

              {/* Phone */}
              <div className="cs-form-group">
                <label className="cs-label">Phone Number</label>
                <input
                  type="tel"
                  name="phone"
                  className="cs-input"
                  placeholder="e.g. +44 7700 900123"
                  value={phone}
                  onChange={(e) => {
                    setPhone(e.target.value)
                    setPhoneError(regExpChecker("phone", e.target.value));
                  }}
                />
                <p style={{ color: "red" }}>{phoneError}</p>
              </div>

              {/* Company */}
              {/* <div className="cs-form-group">
                <label className="cs-label">Company Name</label>
                <input
                  type="text"
                  name="company"
                  className="cs-input"
                  placeholder="Your Company"
                  value={csFormData.company}
                  onChange={handleCsInputChange}
                />
              </div> */}

              {/* Message */}
              <div className="cs-form-group">
                <label className="cs-label">Your Message</label>
                <textarea
                  name="message"
                  className="cs-textarea"
                  placeholder="Type your message here..."
                  rows={5}
                   value={message}
                  onChange={(e) => {
                    setMessage(e.target.value);
                    setMessageError(regExpChecker("string", e.target.value));
                  }}
                  required
                />
                <p style={{ color: "red" }}>{messageError}</p>
              </div>

              {/* Privacy Checkbox */}
              <div className="cs-privacy-row">
                <input
                  type="checkbox"
                  name="privacy"
                  id="cs-privacy"
                  className="cs-checkbox"
                  checked={privacy}
                  onChange={(e) => 
                    setPrivacy(e.target.checked)}
                />
                <label htmlFor="cs-privacy" className="cs-privacy-label">
                  I agree to the processing of my data as described in the{" "}
                  <a href="#" className="cs-privacy-link">Privacy Policy</a>.
                </label>
              </div>

              {/* Submit Button */}
              <button type="submit" className="cs-submit-btn">
                Send Message
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"
                  className="cs-btn-arrow">
                  <line x1="5" y1="12" x2="19" y2="12" />
                  <polyline points="12 5 19 12 12 19" />
                </svg>
              </button>

            </form>
          )}
        </div>

      </div>
    </section>
  );
};

export default ContactSection;